var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":"","pa-5":""}},[_c('div',{staticStyle:{"margin":"50px 0 10px 0"}},[_c('ColorPage')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }